import React from "react";

const IconAmex = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path
                fillRule="nonzero"
                style={{fill: props?.iconFill}}
                d="m18.53 10.339-1.009 1.091-.978-1.091h-3.197v3.329h3.147l1.016-1.103.978 1.103h1.022l-1.486-1.655 1.486-1.674zm-2.439 2.639h-1.956v-.665h1.743v-.677h-1.743v-.608h1.994L17 12zm-8.715-2.752-.01-.02h.01zm2.997 2.37-1.041-2.257H8.034v3.147l-1.348-3.147H5.502l-1.423 3.329h.865l.307-.746h1.655l.307.746h1.618V11.06l1.154 2.608h.702l1.147-2.608.006 2.608h.784v-3.329h-1.292zm-4.84-.364.545-1.329.545 1.329zM22 4H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-1 10.32h-2.859l-.633-.721-.677.721H6.724l-.301-.74h-.69l-.301.74H3l2.031-4.64h4.771l.533 1.198.52-1.198h6.056l.614.708.658-.708H21l-2.038 2.332z">
            </path>
        </svg>
    )
};

export default IconAmex;
